module.exports = __webpack_public_path__ + "img/body_face_side_man.ce2faafa.png";